import { memo } from 'react';
import { SourcesUsesSecuritiesTable } from '@dealstack/frontend/app/pages/Valuations/views/SourcesAndUses/components/SourcesUsesSecuritiesTable';
import { SecuritiesTableProps } from '@dealstack/frontend/app/pages/Valuations/views/SourcesAndUses/types';

export const DistributionsTable = memo(
	({
		person,
		summary,
		baseCurrency,
		fxRates,
		isSummaryLoading,
	}: SecuritiesTableProps & { isSummaryLoading: boolean }) => {
		return (
			<SourcesUsesSecuritiesTable
				person={person}
				summary={summary}
				baseCurrency={baseCurrency}
				fxRates={fxRates}
				isLoading={isSummaryLoading}
				variant="distributions"
			/>
		);
	},
	(prevProps, nextProps) => {
		const isPersonSame = prevProps.person.id === nextProps.person.id;
		const isSummaryRefSame = prevProps.summary === nextProps.summary;
		const isBaseCurrencySame = prevProps.baseCurrency === nextProps.baseCurrency;
		const areFxRatesSame = prevProps.fxRates === nextProps.fxRates;

		return isPersonSame && isSummaryRefSame && isBaseCurrencySame && areFxRatesSame;
	}
);
